var mega_menu_new_slider = new Swiper(".mega_menu_new_slider", {
  slidesPerView: 'auto',
  spaceBetween: 8,
  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true
  }
});
  var pdp_cart_slider = new Swiper(".pdp_cart_slider", {
  slidesPerView: 'auto',
  spaceBetween: 8,
  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true
  }
});
var tab_prod_slider = new Swiper(".tab_prod_slider", {
  slidesPerView: 4,
  spaceBetween: 24,
  pagination: {
      el: '.swiper-pagination.tab_prod_pagination',
			clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next.tab_prod_arrow",
      prevEl: ".swiper-button-prev.tab_prod_arrow",
    },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16
    },
    1080: {
      slidesPerView: 4,
      spaceBetween: 24
    }
  },
  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true
  }
});

// collection slider
var collection_slider = new Swiper(".collection_slider", {
  slidesPerView: 'auto',
  spaceBetween: 16,
  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true
  }
});

var pdp_cart_slider = new Swiper(".pdp_cart_slider", {
  slidesPerView: 'auto',
  spaceBetween: 8,
  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true
  }
});

document.querySelectorAll('.swiper-slide > a').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    e.preventDefault(); // stop default navigation
    // console.log('Clicked link href:', anchor.href);
    window.location.href = anchor.href; // open it manually
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("li.main_menu_cu").forEach(function (menuItem) {
    menuItem.addEventListener("click", function (event) {
      event.preventDefault();

      const megaMenu = menuItem.closest(".mega-menu");
      if (!megaMenu) return;

      const childSubMenu = menuItem.querySelector("ul.sub_menu_cu");

      megaMenu.querySelectorAll("li.main_menu_cu").forEach(function (item) {
        item.classList.remove("active");
      });

      menuItem.classList.add("active");

      megaMenu.querySelectorAll("ul.sub_menu_cu").forEach(function (submenu) {
        submenu.style.display = "none";
      });

      if (childSubMenu) {
        childSubMenu.style.display = "flex";
      }
    });
  });
});